import { notFoundRouteCase, route, routerSwitch } from "widgets-for-react";
import { Updater } from "widgets-for-react";
import { application } from "../allIncludedModules";
import { State, stateUpdaters } from "../root/root.state";
import { Routes } from "../../../Shared/Frontend/utils/routes.shared";
import { Pages, routeUpdaters } from "./routes.state";
import { updatePageViewBasedOnState } from "../cms/utils/pageViews";

export const routeWidgets: Routes<State, Pages> =
{
  ...application.routeWidgetsObject<State, Pages>(),
  home: route(routeUpdaters.home.url, routeUpdaters.home.jumpTo),
}

export const routes = () =>
  routerSwitch<Updater<State>>()([
    ...application.routeWidgets<State, Pages>(),
    routeWidgets.home,
    notFoundRouteCase<Updater<State>>(stateUpdaters.routes.home.jumpTo),
  ])
  .map<Updater<State>>(u => os => updatePageViewBasedOnState(u, os))
